import { ApplicationRef, NgZone } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';
import { ContentComponent } from '@sanopass-frontend/landing-spa-shared';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { BlogInfoComponent } from './app/features/blog/info/component';
import { CKEditorComponent } from './app/features/ckeditor/plugin/component';
import { ImageCropperComponent } from './app/features/image-cropper/plugin/component';
import { prepareApp } from './mocks/msw.initializer';

prepareApp().then(async () => {
  /// 1
  const appref: ApplicationRef = await createApplication(appConfig);
  const injector = appref.injector;

  const ngZone = injector.get(NgZone);
  ngZone.run(() => {
    console.log('Angular Elements запущен');
  });

  const blogImageCropperElement = createCustomElement(BlogInfoComponent, {
    injector,
  });

  customElements.define('app-blog-image-cropper', blogImageCropperElement);

  const influencersImageCropperElement = createCustomElement(
    ImageCropperComponent,
    {
      injector,
    },
  );

  customElements.define(
    'app-influencers-image-cropper',
    influencersImageCropperElement,
  );

  const blogCKEditorElement = createCustomElement(CKEditorComponent, {
    injector,
  });

  customElements.define('app-blog-ckeditor', blogCKEditorElement);

  const blogArticlePreviewElement = createCustomElement(ContentComponent, {
    injector,
  });

  customElements.define('app-content-article', blogArticlePreviewElement);

  const appElement = createCustomElement(App, { injector });
  customElements.define('app-sanopass-spa-admin', appElement);

  /// 2
  const appref2: ApplicationRef = await createApplication(appConfig);
  const injector2 = appref2.injector;

  const ngZone2 = injector2.get(NgZone);
  ngZone2.run(() => {
    console.log('Angular Elements 2 запущен');
  });

  const appElement2 = createCustomElement(App, { injector: injector2 });
  customElements.define('app-sanopass-spa-admin2', appElement2);
});
